import PropTypes from "prop-types";

const userManagePropTypes = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string
});

export default userManagePropTypes;
